import { Link } from "react-router-dom";
import SecondaryButton from "../../components/Button/SecondaryButton";
import { ShoppingCart } from "lucide-react";

interface ProductContentProps {
  image: string;
  title: string;
  cta?: string;
  productLink?: string;
  product?: any;
  price?: number | any;
  shorten_name?: string;
}

const ProductContent = ({
  image,
  title,
  cta,
  productLink,
  product,
  price,
  shorten_name
}: ProductContentProps) => {
  
  const truncatedTitle = title.length > 30 
    ? `${title.substring(0, 20)}...` 
    : title;

  return (
    <div className="relative">
      <Link to={productLink || ""}>
        <div className="flex flex-col items-center justify-between h-full px-2 md:px-4 pb-3 md:pb-4 overflow-hidden opacity-90 z-20 relative">
          <div className="relative flex justify-center py-2">
            <img
              src={image}
              alt={title}
              className="w-full h-[200px] md:h-[200px] lg:h-[200px] object-contain"
            />
          </div>

          <div className="h-12 md:h-16 flex items-center">
            <p className="text-center text-[#005D6E] line-clamp-2 w-full text-lg font-semibold md:text-lg lg:text-xl ">
              {truncatedTitle}
            </p>
          </div>

          {price && (
            <div className="text-center">
              <p className="text-[#005D6E] text-xl md:text-xl lg:text-2xl font-semibold">
                R {price}
              </p>
              <p className="text-sm md:text-base text-[#005D6E] opacity-75 h-4 md:h-5">
                (Price includes VAT)
              </p>
            </div>
          )}

          <div className=" md:mt-2 w-full flex justify-center mt-4">
            <SecondaryButton
              label={"VIEW PRODUCT"}
              className="w-auto text-base md:text-lg"
              icon={<ShoppingCart size={18} className="mr-2" />}
            />
          </div>
        </div>
      </Link>
    </div>
  );
};

export default ProductContent;